module.exports = __webpack_public_path__ + "media/images/feed-36d419ec94e94c19e1380f2f75f746a5.png";